const Positions = () => {
  return <h1>My Positions</h1>;
};

export default Positions;
